import { GameCommunicationCancelledProcessor as CoreCancelledProcessor, GameCommunicationMessageType } from '@pp/core';

import type { GameStore } from '../../../store/GameStore';
import GameCustomEventService from '../../../utilities/GameCustomEventService';
import { MWSpecificEvents } from '../../../config/events';

export class GameCommunicationGameCancelledProcessor extends CoreCancelledProcessor {
  process(message: GameCommunicationMessageType, store: GameStore): void {
    GameCustomEventService.dispatchGameEvent(MWSpecificEvents.CLEAR_TIMERS);
    super.process(message, store);
  }
}
